



























































import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { MatchNoneAndGSRPContent } from "@/models/content/match-none-and-gsrp";
import { AppData } from "@/models/app-data";
import CommonMixin, {
  WORKFLOW_PREFERRED_GREAT_START,
} from "@/mixins/common-mixins";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {PageLoader},
})
export default class MatchNoneAndGSRP extends Mixins(CommonMixin) {
  content: MatchNoneAndGSRPContent = {} as MatchNoneAndGSRPContent;
  appData = {} as AppData;
  loadDataFinished = false;
  textDirection = 'ltr'

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchNoneAndGSRPContent();
      this.textDirection = contentService.TextDirection();    

      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = WORKFLOW_PREFERRED_GREAT_START;
        this.saveAppData(this.appData);

        await this.putWorkflowStep( this.appData.workflowId, "MatchNoneAndGSRP") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );
      }
      this.loadDataFinished = true;
      this.postNavigatedToParent();
    } catch (error) {
      this.showError(error as any);
    }
  }

  public handleApply4YearOlds(): void {
    this.appData.numberOfChildrenApplying = this.appData.number4YearOlds;
    this.appData.applyGreatStart = true;
    this.saveAppData(this.appData);
    this.$router.push({ path: "StartApplication" });
  }

  public handleApplyAll(): void {
    this.appData.numberOfChildrenApplying = this.appData.numberChildren;
    this.appData.applyGreatStart = true;
    this.saveAppData(this.appData);
    this.$router.push({ path: "StartApplication" });
  }

  disableButton(): boolean {
    return !this.loadDataFinished;
  }
}
